import { render } from "./informationDetail.vue?vue&type=template&id=ac1fc2a2"
import script from "./informationDetail.vue?vue&type=script&lang=js"
export * from "./informationDetail.vue?vue&type=script&lang=js"

import "./informationDetail.vue?vue&type=style&index=0&id=ac1fc2a2&lang=scss"

import exportComponent from "E:\\developYZ\\yzWebsite\\newWebsite\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__